<div class="inner-page-bg-right">
  <header data-aos="zoom-in" class="aos-init aos-animate">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'"> <img src="./assets/images/logo-inner.png" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="banner-left-text mb-4">
            <h4>Invitation from <b>{{model?.company}}</b> for <b>{{model?.storeDetail?.name}}</b> to Accept as business user.</h4>
             <button class="mt-3" type="submit" mat-raised-button (click)="onClickConfirm()" color="primary">Accept</button>
          </div>
        </div>
      
      </div>
    </div>
  </section>
</div>
<app-admin-footer></app-admin-footer>